import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from '@/services';
import { PaginatedRequest, PaginatedResponse } from '@/types';
import { API_INVENTORY_URL } from '@/utils';
import { AssetModelApi } from '../models';

const assetModelsService = createApi({
  reducerPath: 'assetModelsService',
  baseQuery: createBaseQueryWithReauth(`${API_INVENTORY_URL}/asset-models`),
  tagTypes: ['AssetModels'],
  endpoints: (builder) => ({
    getAssetModels: builder.query<
      PaginatedResponse<AssetModelApi>,
      { search?: string; brandId?: string; paginated: PaginatedRequest }
    >({
      query: ({ search, brandId, paginated }) => {
        const params: any = {
          limit: paginated.pageSize,
          offset: (paginated.page - 1) * paginated.pageSize,
        };

        if (search && search.trim() !== '') {
          params.name = search.trim();
        }

        if (brandId) {
          params.brandId = brandId;
        }

        return {
          url: '',
          params,
        };
      },
      providesTags: ['AssetModels'],
    }),
    createAssetModel: builder.mutation({
      query: (body) => ({
        url: '',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['AssetModels'],
    }),
    updateAssetModel: builder.mutation({
      query: ({ assetModelId, body }) => ({
        url: `/${assetModelId}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['AssetModels'],
    }),
  }),
});

export const {
  useGetAssetModelsQuery,
  useCreateAssetModelMutation,
  useUpdateAssetModelMutation,
} = assetModelsService;

export default assetModelsService;
